import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { bindRefs } from '../../utils/react.js';
import { noop } from '../../utils/util.js';
import { StyledTab } from './StyledTab.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "focused", "onChange", "selected", "value"];
var TabsTab = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      focused = _ref.focused,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      selected = _ref.selected,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var localRef = React.useRef(null);
  React.useEffect(function () {
    if (focused && localRef.current) {
      localRef.current.focus({
        preventScroll: true
      });
    }
  }, [focused]);
  return /*#__PURE__*/jsx(StyledTab, _objectSpread(_objectSpread({}, rest), {}, {
    "aria-selected": selected,
    ref: bindRefs(ref, localRef),
    role: "tab",
    tabIndex: selected ? 0 : -1,
    onClick: function onClick() {
      return onChange(value);
    },
    children: children
  }));
});
TabsTab.displayName = "TabsTab";

export { TabsTab };
